import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import download from "../Image/download (2).png"
import axios from "axios"
import office from '../Image/india-img.png'
import office1 from '../Image/italy.png'
import office2 from '../Image/paris.png'
function ContactUs() {
    const [fname, setFname] = useState("");
    const [email, setEmail] = useState("");
    const [contactNumber, setcontactNumber] = useState("");
    const [request, setRequest] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const contactus = async () => {
        if (!fname || !email || !contactNumber || !request || !message) {
            alert("Please fill out all fields.");
            return;
        }

        const payload = {
            FullName: fname,
            Email: email,
            MobileNo: contactNumber,
            Requirement: request,
            EnquiryMessage: message,
        };

        try {
            setLoading(true);
            const res = await axios.post(
                "https://api.ndtechland.com/Api/NdTechlandContactDetails/AddContact",
                payload
            );

            if (res.data.succeeded) {
                alert("✅ Message sent successfully!");
                setFname("");
                setEmail("");
                setcontactNumber("");
                setRequest("");
                setMessage("");
            } else {
                alert("❌ Something went wrong. Please try again later.");
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("⚠️ Failed to send message. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div>
                <img
                    src="https://reflectiveit.com/wp-content/uploads/2025/12/contact-us-scaled-1.jpg"
                    alt="Contact Us"
                    style={{
                        width: "100%",
                        height: "380px",
                        objectFit: "cover",
                        display: "block",
                    }}
                />
            </div>

            <section className="contact-page pad-tb py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        {/* Left - Contact Form */}
                        <div className="col-lg-6 col-md-10">
                            <div className="common-heading text-l mb-4">
                                <span className="text-primary fw-semibold">Contact Now</span>
                                <h2 className="mt-2 mb-2">Have Questions? Write a Message</h2>
                                <p className="text-muted">
                                    We’ll get back to you as soon as we receive your message.
                                </p>
                            </div>
                            <div className="form-block">
                                <form id="contactForm" data-bs-toggle="validator" className="shake">
                                    <div className="row">
                                        <div className="form-group col-sm-6 ">
                                            <input
                                                type="text"
                                                placeholder="Enter your name"
                                                value={fname}
                                                onChange={(e) => setFname(e.target.value)}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-6 mb-3">
                                            <input
                                                type="email"
                                                placeholder="Enter your email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className="form-control"
                                                required
                                            />
                                            <div className="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <input
                                                type="text"
                                                placeholder="Enter your mobile number"
                                                value={contactNumber}
                                                onChange={(e) => setcontactNumber(e.target.value)}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-6">
                                            <select
                                                className="form-select"
                                                value={request}
                                                onChange={(e) => setRequest(e.target.value)}
                                                required
                                            >
                                                <option value="">Select Requirement</option>
                                                <option value="Website Development">Website Development</option>
                                                <option value="Web Application">Web Application</option>
                                                <option value="Mobiles Application">Mobiles Application</option>
                                                <option value="Software Development">Software Development</option>
                                                <option value="Digital Marketing">Digital Marketing</option>
                                                <option value="Influencer Marketing">Influencer Marketing</option>
                                                <option value="Brand Promotion">Brand Promotion</option>
                                                <option value="CCTV Surveillance">CCTV Surveillance</option>
                                                <option value="Social Media Marketing">Social Media Marketing</option>
                                                <option value="Search Engine Optimization">
                                                    Search Engine Optimization
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <textarea
                                            rows="5"
                                            placeholder="Enter your message"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            className="form-control"
                                            required
                                        ></textarea>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={contactus}
                                        className="btn btn-primary w-100 py-2"
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Submit"}
                                    </button>
                                    <div id="msgSubmit" className="h3 text-center hidden"></div>
                                    <div className="clearfix"></div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-5 v-center">
                            <div className="contact-details">
                                <div className="contact-card wow fadeIn" data-wow-delay=".2s">
                                    <div className="info-card v-center">
                                        <span><i className="fas fa-phone-alt"></i> Phone:</span>
                                        <div className="info-body">
                                            <p>Assistance hours: Monday – Friday, 9 am to 5 pm</p>
                                            <a href="tel:+10000000000">
                                                +91 8826302378</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="email-card mt30 wow fadeIn" data-wow-delay=".5s">
                                    <div className="info-card v-center">
                                        <span><i className="fas fa-envelope"></i> Email:</span>
                                        <div className="info-body">
                                            <p>Our support team will get back to in 24-h during standard business hours.</p>
                                            <a href="mailto:info@businessname.com">
                                                info@ndtechland.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
          <section className="our-office pad-tb">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="common-heading">
                                <span>Our Locations</span>
                                <h2>Our Office</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-sm-6 shape-loc wow fadeIn" data-wow-delay=".2s">
                            <div className="office-card hoshd">
                                {/* <div className="landscp">
                                    <img src={office} alt="location" className="img-fluid" />
                                </div> */}
                                <div className="info-text-div">
                                    <h4>NCR Office</h4>
                                    <h6 className="mt10">Corporate Address</h6>
                                    <p>D-159, First Floor, Sector 7, Noida, Uttar Pradesh-201301</p>
                                    <ul className="-address-list mt10">
                                        <li><a href="mailto:hr@ndtechland.com"><i className="fas fa-envelope"></i>
                                           hr@ndtechland.com</a></li>
                                        <li><a href="tel:+91 8826302378"><i className="fas fa-phone-alt"></i>  +91 8826302378</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 shape-loc wow fadeIn" data-wow-delay=".4s">
                            <div className="office-card hoshd">
                                {/* <div className="landscp">
                                    <img src={office1} alt="location" className="img-fluid" />
                                </div> */}
                                <div className="info-text-div">
                                    <h4>Bihar office</h4>
                                    <h6 className="mt10">Branch Office</h6>
                                    <p>Plot No.2200,Near Dhanaut Post,Mahubag, Patna-801506,Bihar,India</p>
                                    <ul className="-address-list mt10">
                                        <li><a href="mailto:info@ndtechland.com"><i className="fas fa-envelope"></i>
                                            info@ndtechland.com</a></li>
                                        <li><a href="tel:+91 9999 179 132"><i className="fas fa-phone-alt"></i> +91 9999 179 132</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 shape-loc wow fadeIn" data-wow-delay=".6s">
                            <div className="office-card hoshd">
                                {/* <div className="landscp">
                                    <img src={office2} alt="location" className="img-fluid" />
                                </div> */}
                                <div className="info-text-div">
                                    <h4>Gujrat office</h4>
                                    <h6 className="mt10">Branch Office</h6>
                                    <p>811, sharan Circle Hub Zundal Circle Zundal Gandhinagar-382424</p>
                                    <ul className="-address-list mt10">
                                        <li><a href="mailto:info@ndtechland.com"><i className="fas fa-envelope"></i>
                                            hr@ndtechland.com</a></li>
                                        <li><a href="tel:+91 9716 41 2565"><i className="fas fa-phone-alt"></i>+91 9716412565</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactUs